import { AhooksInfiniteScrollFrame } from "@/components/AhooksInfiniteScrollFrame";
import { DateRangePicker } from "@/components/DateRangePicker";
import { FilterLayout } from "@/components/FilterLayout";
import SubLayout from "@/components/SubLayout";
import { AmountOrder } from "@/pages/orders/components/AmountOrder";
import { amountFormat } from "@/utils/tool";
import { useCreation } from "ahooks";
import { PullToRefresh, SafeArea } from "antd-mobile";
import dayjs from "dayjs";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import styles from "./index.module.scss";
import { useLogic } from "./logic";

export function PageUserBill() {
  const logic = useLogic();
  const navigate = useNavigate();
  const [dateRange, setDateRange] = useState<[string, string]>([
    logic.params.startTime || "",
    logic.params.endTime || "",
  ]);
  const [order, setOrder] = useState<"asc" | "desc">("desc");
  // const [] = useState<[string, string]>([])

  const filters = useCreation(() => {
    return [
      {
        title: "",
        key: "paymentType",
        multiple: true,
        items: Object.keys(logic.changeTypeMap).map((key) => ({
          value: key,
          text: logic.changeTypeMap[key],
        })),
      },
    ];
  }, [logic.changeTypeMap]);

  const onSearch = (newParams: any) => {
    logic.paramsRef.current = { ...logic.paramsRef.current, ...newParams };
    logic.infiniteList.reload();
  };

  const onSubmit = (filters: Record<string, string[]>) => {
    onSearch({
      type: filters.paymentType.length
        ? filters.paymentType.join(",")
        : undefined,
      page: 1,
    });
  };

  useEffect(() => {
    onSearch({
      startTime: dateRange[0]
        ? dayjs(dateRange[0]).format("YYYY-MM-DD 00:00:00")
        : undefined,
      endTime: dateRange[1]
        ? dayjs(dateRange[1]).format("YYYY-MM-DD 23:59:59")
        : undefined,
      page: 1,
    });
  }, [dateRange]);

  return (
    <SubLayout title={"个人账变"}>
      <div className={styles.page} ref={logic.scollableRef}>
        <section className={styles.filter}>
          <div className={styles.header}>
            <div className={styles.headerItem}>账变时间</div>
            <div className={styles.headerItem}>账变类型</div>
            <div className={styles.headerItem}>账变金额</div>
          </div>
          <FilterLayout
            items={filters}
            filters={{ paymentType: logic.params.type?.split(",") || [] }}
            onChange={onSubmit}
          >
            <span>排序方式 </span>
            {/* <AmountOrder order={order} onChange={setOrder} /> */}
            <DateRangePicker value={dateRange} onChange={setDateRange} />
          </FilterLayout>
        </section>
        <section className={styles.content}>
          <PullToRefresh onRefresh={() => logic.infiniteList.reloadAsync()}>
            <AhooksInfiniteScrollFrame {...logic.infiniteList}>
              {logic.infiniteList.data?.list
                // .sort((a, b) => {
                //   if (order === "desc") {
                //     return Number(b.amount) - Number(a.amount);
                //   } else {
                //     return Number(a.amount) - Number(b.amount);
                //   }
                // })
                .map((item) => {
                  return (
                    <div className={styles.listItem} key={item.id} onClick={()=>navigate(`/bill_order_detail/${item.id}`)}>
                      <div className={styles.listItemDate}>
                        <div>{dayjs(item.createTime).format("YYYY/MM/DD")}</div>
                        <div>{dayjs(item.createTime).format("HH:mm:ss")}</div>
                      </div>
                      <div className={styles.listItemType}>
                        {item.type_name}
                      </div>
                      <div className={styles.listItemAmount}>
                        {amountFormat(item.amount)}
                      </div>
                    </div>
                  );
                })}
            </AhooksInfiniteScrollFrame>
          </PullToRefresh>
          <SafeArea position="bottom" />
        </section>
      </div>
    </SubLayout>
  );
}
